import { useMemo, useCallback } from 'react';
import { useCheckboxListSelectedOptions, useCheckboxListOptionsChange } from '../abstract/checkbox-list';

export function useTypeFilter({
  config,
  query,
  setFilters,
  updateQuery,
  status,
}) {
  let typeDefaultOptions = useTypeOptions({ status, buckets: config.propertyTypesOptionsByStatus });

  let { checked: types, options: typeOptions, onToggle: onTypeToggle } = useCheckboxListSelectedOptions(query.types, typeDefaultOptions);

  useCheckboxListOptionsChange({
    options: types,
    filterKey: `types`,
    filterValueKey: `type`,
    filterGroupKey: `maintype`,
    setFilters,
    updateQuery,
  });

  let typeCaptionFormatter = useTypeCaptionFormatter();

  return { types, typeOptions, typeCaptionFormatter, onTypeToggle };
}

function useTypeOptions({ status, buckets }) {
  let bucketsArr = useMemo(() => Object.entries(buckets).map(x => ({ status: x[0], options: x[1] })), []);

  return useMemo(
    () => status ? bucketsArr.find(x => x.status.includes(status.value)).options : bucketsArr[0],
    [status],
  );
}

function useTypeCaptionFormatter() {
  return useCallback((options) => {
    if (options[0].isChecked) return `All Property Types`;

    let activeOptions = options.filter(x => x.isChecked);

    if (!activeOptions.length) return `All Property Types`;

    let activeSingleOptions = activeOptions.filter(x => !x.isGroup);
    let activeGroupOptions = activeOptions.filter(x => x.isGroup);

    if (activeGroupOptions.length && activeSingleOptions.filter(x => !activeGroupOptions.some(y => y.group === x.group)).length === 0) {
      activeSingleOptions = [];
    }

    if (activeSingleOptions.length === 1) return activeSingleOptions[0].name;
    if (activeSingleOptions.length === 2) return `${activeSingleOptions[0].name} and ${activeSingleOptions[1].name}`;
    if (activeSingleOptions.length > 2) return `${activeSingleOptions[0].name} and ${activeSingleOptions.length - 1} others`;

    if (activeGroupOptions.length === 1) return activeGroupOptions[0].name;
    return `${activeGroupOptions[0].name} and ${activeGroupOptions[1].name}`;
  }, []);
}
